import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import NavigationItem from '@/repositories/data/sidebar/NavigationItem';

export default class NavigationItemRepository extends BaseCrudRepository<number, NavigationItem, NavigationItem> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/navigation-item/');
    }
}
